var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7831 4.97282C23.9322 5.12193 24.0045 5.31879 23.9999 5.51418V10.7876C23.9999 11.1967 23.6682 11.5284 23.2591 11.5284C22.85 11.5284 22.5184 11.1967 22.5184 10.7876V7.28512L15.3616 14.4419C15.0723 14.7312 14.6033 14.7312 14.314 14.4419C14.0247 14.1526 14.0247 13.6836 14.314 13.3944L21.471 6.23734H17.9681C17.559 6.23734 17.2274 5.9057 17.2274 5.4966C17.2274 5.0875 17.559 4.75586 17.9681 4.75586H23.2591H23.2592C23.2705 4.75586 23.2818 4.75611 23.2931 4.75662C23.4713 4.7647 23.6471 4.83677 23.7831 4.97282ZM5.48149 10.7877C5.48149 9.73568 6.33428 8.88289 7.38625 8.88289H12.6773C13.0864 8.88289 13.418 8.55124 13.418 8.14214C13.418 7.73304 13.0864 7.4014 12.6773 7.4014H7.38625C5.51608 7.4014 4 8.91748 4 10.7877V21.3697C4 23.2399 5.51608 24.7559 7.38625 24.7559H17.9683C19.8385 24.7559 21.3545 23.2399 21.3545 21.3697V16.0787C21.3545 15.6696 21.0229 15.3379 20.6138 15.3379C20.2047 15.3379 19.8731 15.6696 19.8731 16.0787V21.3697C19.8731 22.4217 19.0203 23.2745 17.9683 23.2745H7.38625C6.33428 23.2745 5.48149 22.4217 5.48149 21.3697V10.7877Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.39bd03ad.svg";
export { ForwardRef as ReactComponent };